import React, { useEffect, useState } from "react";
import styless from './Settings.module.css';
import { useDispatch, useSelector } from "react-redux";
import { config } from '../../app/utils/config';
import styles from '../../containers/collabs/CollabsView.module.css'
import Langs, { Localize } from '../../app/lang/langs';
import { Button as ButtonPR } from 'primereact/button';
import { Col, Row } from 'react-bootstrap';
import { DynamicButton } from "../../components/buttons/DynamicButton";
import { updateManagersPermissions } from "./settingsSlice";
import { showSuccessToast } from "../../app/utils/helpers";

export default function ManagersPermissionTab() {

    const dispatch = useDispatch()
    
    const permissions = useSelector((state) => state.settings.managersPermission)

    const roles = ["RESPCOMPTE", "SDM", "MANAGER"]
    const globalPermissions = [
        config.scopes.collabs,
        config.scopes.warnings,
        config.scopes.vcomp,
        config.scopes.ventr,
        config.scopes.medicalVisits,
        config.scopes.opportunities,
        config.scopes.reports
    ]
    const teamPermissions = [
        config.scopes.shifts,
        config.scopes.leaves,
        config.scopes.groups,
        config.scopes.evaluations
    ]
    const initialPermissions = roles.reduce((acc, role) => {
        acc[role] = {
            global: {
                view: [],
                edit: [],
                remove: []
            },
            team: {
                view: [],
                edit: []
            }
        };
        return acc;
    }, {})

    const [managersPermissions, setManagersPermissions] = useState(initialPermissions)

    useEffect(() => { 
        console.log(managersPermissions) 
    }, [managersPermissions])

    useEffect(() => {
        if (permissions) {
            setManagersPermissions(() => {
                const newPermissions = JSON.parse(JSON.stringify(initialPermissions));
                Object.keys(newPermissions).forEach(role => {
                    if (!permissions[role]) {
                        newPermissions[role] = {
                            global: {
                                [config.permissionTypes.view]: [],
                                [config.permissionTypes.edit]: [],
                                [config.permissionTypes.remove]: [...globalPermissions]
                            },
                            team: {
                                [config.permissionTypes.view]: [...teamPermissions],
                                [config.permissionTypes.edit]: [],
                                [config.permissionTypes.remove]: []
                            }
                        };
                    }
                });
                Object.keys(permissions).forEach(role => {
                    if (!newPermissions[role]) return;
                    Object.keys(permissions[role]).forEach(scopeType => {
                        Object.keys(config.permissionTypes).forEach(permissionType => {
                            if (permissions[role][scopeType] && permissions[role][scopeType][permissionType]) {
                                const validScopes = scopeType === "global" ? globalPermissions : teamPermissions;
                                let filteredScopes = permissions[role][scopeType][permissionType].filter(scope => validScopes.includes(scope));
                                if (
                                    scopeType === "global" &&
                                    permissionType !== config.permissionTypes.view &&
                                    permissionType !== config.permissionTypes.edit
                                ) {
                                    newPermissions[role].global[config.permissionTypes.remove].push(...filteredScopes);
                                    return;
                                }
                                if (
                                    scopeType === "team" &&
                                    permissionType !== config.permissionTypes.edit
                                ) {
                                    newPermissions[role].team[config.permissionTypes.view].push(...filteredScopes);
                                    return;
                                }
                                newPermissions[role][scopeType][permissionType] = filteredScopes;
                            }
                        });
                    });
                    const assignedGlobalScopes = [
                        ...newPermissions[role].global[config.permissionTypes.view],
                        ...newPermissions[role].global[config.permissionTypes.edit]
                    ];
                    const unassignedGlobalScopes = globalPermissions.filter(scope => !assignedGlobalScopes.includes(scope));
                    newPermissions[role].global[config.permissionTypes.remove].push(...unassignedGlobalScopes);
                    const assignedTeamScopes = [
                        ...newPermissions[role].team[config.permissionTypes.view],
                        ...newPermissions[role].team[config.permissionTypes.edit]
                    ];
                    const unassignedTeamScopes = teamPermissions.filter(scope => !assignedTeamScopes.includes(scope));
                    newPermissions[role].team[config.permissionTypes.view].push(...unassignedTeamScopes);
                });
                return newPermissions;
            });
        }
    }, [permissions])

    const handlePermissionChange = (role, scopeType, scope, newType) => {
        setManagersPermissions(prevState => {
            const updatedPermissions = { ...prevState };
            if (!updatedPermissions[role]) {
                updatedPermissions[role] = {
                    global: {
                        [config.permissionTypes.view]: [],
                        [config.permissionTypes.edit]: [],
                        [config.permissionTypes.remove]: []
                    },
                    team: {
                        [config.permissionTypes.view]: [],
                        [config.permissionTypes.edit]: [],
                        [config.permissionTypes.remove]: []
                    }
                };
            }
            if (!updatedPermissions[role][scopeType]) {
                updatedPermissions[role][scopeType] = {
                    [config.permissionTypes.view]: [],
                    [config.permissionTypes.edit]: [],
                    [config.permissionTypes.remove]: []
                };
            }
            Object.keys(config.permissionTypes).forEach(type => {
                const typeKey = config.permissionTypes[type];

                if (!updatedPermissions[role][scopeType][typeKey]) {
                    updatedPermissions[role][scopeType][typeKey] = [];
                }
                updatedPermissions[role][scopeType][typeKey] = updatedPermissions[role][scopeType][typeKey].filter(item => item !== scope);
            });
            if (!updatedPermissions[role][scopeType][newType]) {
                updatedPermissions[role][scopeType][newType] = [];
            }
            updatedPermissions[role][scopeType][newType].push(scope);
            return updatedPermissions;
        })
    }

    const handleManagerPermissionsUpdate = (permissions) => {
        dispatch(updateManagersPermissions({ managers: permissions }))
    }

    return (
        <div className={styless.menuContentManagersPer}>
            {Object.keys(managersPermissions).map(role => (
                <div key={role} className="role-section my-3">
                    <Col lg={12} className="d-flex justify-content-center">
                        <h3 className="border-top border-bottom">
                            {role}
                        </h3>
                    </Col>
                    <br />
                    <h5><Langs str='GLOBAL_PERMISSIONS' /></h5>
                    {globalPermissions.map(scope => (
                        <Row key={scope} className="border-top py-2">
                            <Col lg={6} xl={7} xxl={8} className="pt-2 ps-2"><Langs str={scope} /></Col>
                            <Col lg={6} xl={5} xxl={4} className={`${styles.buttonGroupStyle} d-flex justify-content-center p-1`}>
                                {Object.values(config.permissionTypes).map(type => (
                                    <ButtonPR
                                        key={type}
                                        label={<Langs str={type == 'remove' ? 'invisible' : type == 'view' ? 'visible' : type} />}
                                        icon={
                                            type === config.permissionTypes.view
                                                ? "pi pi-eye"
                                                : type === config.permissionTypes.remove
                                                    ? "pi pi-eye-slash"
                                                    : "pi pi-pencil"
                                        }
                                        className={`m-1 ${managersPermissions[role].global[type]?.includes(scope)
                                            ? type === config.permissionTypes.view
                                                ? "p-button-success"
                                                : type === config.permissionTypes.remove
                                                    ? "p-button-danger"
                                                    : "p-button-warning"
                                            : "p-button-secondary"
                                            }`}
                                        onClick={() => handlePermissionChange(role, "global", scope, type)}
                                    />
                                ))}
                            </Col>
                        </Row>
                    ))}
                    <h5><Langs str='TEAMS_PERMISSIONS' /></h5>
                    {teamPermissions.map(scope => (
                        <Row key={scope} className="border-top py-2">
                            <Col lg={7} xl={8} xxl={9} className="pt-2 ps-3"><Langs str={scope} /></Col>
                            <Col lg={5} xl={4} xxl={3} className={`${styles.buttonGroupStyle} d-flex justify-content-center p-1`}>
                                {Object.values(config.permissionTypes)
                                    .filter(type => type !== config.permissionTypes.remove)
                                    .map(type => (
                                        <ButtonPR
                                            key={type}
                                            label={Localize(type)}
                                            icon={type === config.permissionTypes.view ? "pi pi-eye" : "pi pi-pencil"}
                                            className={`m-1 ${managersPermissions[role].team[type]?.includes(scope)
                                                ? (type === config.permissionTypes.view ? "p-button-success" : "p-button-warning")
                                                : "p-button-secondary"
                                                }`}
                                            onClick={() => handlePermissionChange(role, "team", scope, type)}
                                        />
                                    ))
                                }
                            </Col>
                        </Row>
                    ))}
                </div>
            ))}
            <Col lg={12} className="d-flex justify-content-center my-4">
                <Col lg={2}>
                    <DynamicButton
                        onClick={() => { handleManagerPermissionsUpdate(managersPermissions) }}
                        className='me-auto ms-4 p-button-success'
                        title={<Langs str="update" />}
                        active={true}
                        color="green"
                    />
                </Col>
            </Col>
        </div>
    )
}
